import { ORDERS_SERVICE } from "@/services/orders.service.js";

const state = {postOrderOutput: false, getOrdersOutput: {}, deleteOrderOutput: false, putOrderOutput: false, getOrderByIdOutput: {}, postOrderChangeStatusOutput: false, putOrderUpdateShippingOutput: false, postOrderAddNotesOutput: false};

const actions = {
    //Service to create orders
    postOrder({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postOrderRequest');

        ORDERS_SERVICE.postOrder(input)
            .then(
                output => {
                    commit('postOrderSuccess', output);
                },
                error => {
                    commit('postOrderFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get orders
    getOrders({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getOrdersRequest');

        ORDERS_SERVICE.getOrders(queryParams)
            .then(
                output => {
                    commit('getOrdersSuccess', output);
                },
                error => {
                    commit('getOrdersFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove orders
    deleteOrder({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteOrderRequest');

        ORDERS_SERVICE.deleteOrder(input)
            .then(
                output => {
                    commit('deleteOrderSuccess', output);
                },
                error => {
                    commit('deleteOrderFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update orders
    putOrder({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putOrderRequest');

        ORDERS_SERVICE.putOrder(input)
            .then(
                output => {
                    commit('putOrderSuccess', output);
                },
                error => {
                    commit('putOrderFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get order details
    getOrderById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getOrderByIdRequest');

        ORDERS_SERVICE.getOrderById(id)
            .then(
                output => {
                    commit('getOrderByIdSuccess', output);
                },
                error => {
                    commit('getOrderByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to add a new order status
    postOrderChangeStatus({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postOrderChangeStatusRequest');

        ORDERS_SERVICE.postOrderChangeStatus(input)
            .then(
                output => {
                    commit('postOrderChangeStatusSuccess', output);
                },
                error => {
                    commit('postOrderChangeStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to admin update shipping date
    putOrderUpdateShipping({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putOrderUpdateShippingRequest');

        ORDERS_SERVICE.putOrderUpdateShipping(input)
            .then(
                output => {
                    commit('putOrderUpdateShippingSuccess', output);
                },
                error => {
                    commit('putOrderUpdateShippingFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to add order notes
    postOrderAddNotes({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postOrderAddNotesRequest');

        ORDERS_SERVICE.postOrderAddNotes(input)
            .then(
                output => {
                    commit('postOrderAddNotesSuccess', output);
                },
                error => {
                    commit('postOrderAddNotesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postOrder
    postOrderRequest(state) {
        state.postOrderOutput = null;
    },
    postOrderSuccess(state, output) {
        state.postOrderOutput = true;
    },
    postOrderFailure(state) {
        state.postOrderOutput = false;
    },

    //getOrders
    getOrdersRequest(state) {
    },
    getOrdersSuccess(state, output) {
        state.getOrdersOutput = output;
    },
    getOrdersFailure(state) {
        state.getOrdersOutput = false;
    },

    //deleteOrder
    deleteOrderRequest(state) {
        state.deleteOrderOutput = null;
    },
    deleteOrderSuccess(state, output) {
        state.deleteOrderOutput = true;
    },
    deleteOrderFailure(state) {
        state.deleteOrderOutput = false;
    },

    //putOrder
    putOrderRequest(state) {
        state.putOrderOutput = null;
    },
    putOrderSuccess(state, output) {
        state.putOrderOutput = true;
    },
    putOrderFailure(state) {
        state.putOrderOutput = false;
    },

    //getOrderById
    getOrderByIdRequest(state) {
    },
    getOrderByIdSuccess(state, output) {
        state.getOrderByIdOutput = output;
    },
    getOrderByIdFailure(state) {
        state.getOrderByIdOutput = false;
    },

    //postOrderChangeStatus
    postOrderChangeStatusRequest(state) {
        state.postOrderChangeStatusOutput = null;
    },
    postOrderChangeStatusSuccess(state, output) {
        state.postOrderChangeStatusOutput = true;
    },
    postOrderChangeStatusFailure(state) {
        state.postOrderChangeStatusOutput = false;
    },

    //putOrderUpdateShipping
    putOrderUpdateShippingRequest(state) {
        state.putOrderUpdateShippingOutput = null;
    },
    putOrderUpdateShippingSuccess(state, output) {
        state.putOrderUpdateShippingOutput = true;
    },
    putOrderUpdateShippingFailure(state) {
        state.putOrderUpdateShippingOutput = false;
    },

    //postOrderAddNotes
    postOrderAddNotesRequest(state) {
        state.postOrderAddNotesOutput = null;
    },
    postOrderAddNotesSuccess(state, output) {
        state.postOrderAddNotesOutput = true;
    },
    postOrderAddNotesFailure(state) {
        state.postOrderAddNotesOutput = false;
    },
};

export const orders = {
    namespaced: true,
    state,
    actions,
    mutations
};